import React from 'react';
import ChartTitle from '../ChartTitle';
import {
  Section,
  Header,
  Controls,
  LabeledControl,
  ToggleGroup,
  ToggleOption,
  Selection,
  SubHeader,
  BackgroundColorControl,
} from '../../../reporting/sidebar/components';

function MainConfig() {
  return (
    <Section defaultOpen>
      <Header>Chart</Header>
      <ChartTitle />
      <SubHeader>Style</SubHeader>
      <Controls>
        <LabeledControl title='Bubble size' alignTop>
          <ToggleGroup configurationKey='pointSize'>
            <ToggleOption value='small'>
              <i className='fa-solid fa-circle' style={{ fontSize: 6 }} />
              Small
            </ToggleOption>
            <ToggleOption value='medium'>
              <i className='fa-solid fa-circle' style={{ fontSize: 8 }} />
              Medium
            </ToggleOption>
            <ToggleOption value='large'>
              <i className='fa-solid fa-circle' style={{ fontSize: 11 }} />
              Large
            </ToggleOption>
          </ToggleGroup>
        </LabeledControl>

        <BackgroundColorControl />

        <LabeledControl title='Labels'>
          <Selection
            configurationKey='showLabels'
            options={[
              ['On', true],
              ['Off', false],
            ]}
          />
        </LabeledControl>

        <LabeledControl title='Trendline'>
          <Selection
            configurationKey='trendline'
            options={[
              ['Linear', 'linear'],
              ['Off', false],
            ]}
          />
        </LabeledControl>
      </Controls>
    </Section>
  );
}

export default MainConfig;
